
import { isMobile } from "../../aliud/ts/functions";
export function responsiveBackground() {

	const imgCtn: any = document.getElementsByClassName("switch-images");
	if (!imgCtn.length) return;

	var setImages = function () {
		for (let i = 0; i < imgCtn.length; i++) {
			var xs = imgCtn[i].dataset.srcxs;
			var md = imgCtn[i].dataset.srcmd;
			var src = isMobile() ? xs : md;
			imgCtn[i].style.backgroundImage = "url(" + src + ")";
		};
	};
	setImages();
	document.addEventListener("resize", (e) => {
		setImages();
	})
};